<template>
  <div class="text-black fs-6 fw-normal" style="text-transform: none !important">
    Pflichtfelder sind mit einem <span class="text-primary">*</span> markiert.
  </div>
</template>

<script>
export default {
  setup() {
    return {};
  },
};
</script>

<style lang="scss" scoped></style>
